export const OnboardingVideoUrl = {
  Intro: "/assets/multimedia/onboarding/onboarding_intro.mp4",
  Tutorial: "/assets/multimedia/onboarding/onboarding_tutorial.mp4",
  TutorialGame: "/assets/multimedia/onboarding/onboarding_tutorial_game.mp4",
};
